angular.module('components.media.file', [
  'stack',
  'components.media.FileController'
])

/**
 * The componentFile provides a preview
 * of the file item type
 *
 * @class componentFile
 * @constructor
 * @module components.media.file
 * @example
 *   <component-file
 *     model="form.model">
 *   </component-file>
 */
.directive('componentFile', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: 'components/media/file/file.html',
      controller: 'FileController'
    };
  }
]);
